module.exports = "<div id=\"{{this.chartID}}\"></div>\r\n"